
import React from 'react';
import { useAuth } from '@/contexts/auth/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const RoleDebugger = () => {
  const { 
    user, 
    isAdmin, 
    isMentor, 
    isStudent, 
    userRoles, 
    viewMode,
    canAccessAdminFeatures,
    canAccessMentorFeatures,
    canAccessAgenticFeatures
  } = useAuth();

  return (
    <Card className="mb-6">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">Role Debugger</CardTitle>
      </CardHeader>
      <CardContent className="text-xs space-y-1">
        <div><strong>User ID:</strong> {user?.id || 'Not logged in'}</div>
        <div><strong>Email:</strong> {user?.email || 'N/A'}</div>
        <div><strong>isAdmin:</strong> {isAdmin() ? 'Yes' : 'No'}</div>
        <div><strong>isMentor:</strong> {isMentor() ? 'Yes' : 'No'}</div>
        <div><strong>isStudent:</strong> {isStudent() ? 'Yes' : 'No'}</div>
        <div><strong>Roles:</strong> {userRoles?.join(', ') || 'None'}</div>
        <div><strong>View Mode:</strong> {viewMode === 'default' ? 'Normal' : viewMode}</div>
        <div><strong>Can Access Admin:</strong> {canAccessAdminFeatures() ? 'Yes' : 'No'}</div>
        <div><strong>Can Access Mentor:</strong> {canAccessMentorFeatures() ? 'Yes' : 'No'}</div>
        <div><strong>Can Access Agentic:</strong> {canAccessAgenticFeatures() ? 'Yes' : 'No'}</div>
      </CardContent>
    </Card>
  );
};

export default RoleDebugger;
